<div class="table-container">
  <p-table
    [value]="data()"
    [scrollable]="true"
    [loading]="loading()"
    [rows]="rows()"
    [totalRecords]="totalRecords()"
    [lazy]="true"
    class="p-table-fixed">
    <ng-template #header>
      <tr>
        <th class="cursor-pointer w-[15rem]" pFrozenColumn alignFrozen="left">
          <app-sort-header
            columnName="Nombre"
            columnKey="Code"
            [sortBy]="sortBy()!"
            [sortOrder]="sortOrder()!"
            (toggleSort)="handleToggleSort('Code')"
          />
        </th>
        <th class="cursor-pointer w-[12rem]">
          <app-sort-header
            columnName="Ubicación"
            columnKey="Location.Country"
            [sortBy]="sortBy()!"
            [sortOrder]="sortOrder()!"
            (toggleSort)="handleToggleSort('Location.Country')"
          />
        </th>
        <th class="cursor-pointer w-[12rem]">
          <app-sort-header
            columnName="Año"
            columnKey="Date.Year"
            [sortBy]="sortBy()!"
            [sortOrder]="sortOrder()!"
            (toggleSort)="handleToggleSort('Date.Year')"
          />
        </th>
        <th class="cursor-pointer w-[12rem]">
          <app-sort-header
            columnName="Tipo"
            columnKey="Type"
            [sortBy]="sortBy()!"
            [sortOrder]="sortOrder()!"
            (toggleSort)="handleToggleSort('Type')"
          />
        </th>
        <th class="cursor-pointer w-[10rem]">
          <app-sort-header
            columnName="Unidad"
            columnKey="Unit"
            [sortBy]="sortBy()!"
            [sortOrder]="sortOrder()!"
            (toggleSort)="handleToggleSort('Unit')"
          />
        </th>
        <th class="cursor-pointer w-[8rem]">
          <app-sort-header
            columnName="CO2"
            columnKey="Gases"
            [sortBy]="sortBy()!"
            [sortOrder]="sortOrder()!"
            (toggleSort)="handleToggleSort('CO2')"
          />
        </th>
        <th class="cursor-pointer w-[8rem]">
          <app-sort-header
            columnName="CH4"
            columnKey="Gases"
            [sortBy]="sortBy()!"
            [sortOrder]="sortOrder()!"
            (toggleSort)="handleToggleSort('CH4')"
          />
        </th>
        <th class="cursor-pointer w-[8rem]">
          <app-sort-header
            columnName="N2O"
            columnKey="Gases"
            [sortBy]="sortBy()!"
            [sortOrder]="sortOrder()!"
            (toggleSort)="handleToggleSort('N2O')"
          />
        </th>
        <th class="cursor-pointer w-[8rem]">
          <app-sort-header
            columnName="SF6"
            columnKey="Gases"
            [sortBy]="sortBy()!"
            [sortOrder]="sortOrder()!"
            (toggleSort)="handleToggleSort('SF6')"
          />
        </th>
        <th class="cursor-pointer w-[8rem]">
          <app-sort-header
            columnName="NF3"
            columnKey="Gases"
            [sortBy]="sortBy()!"
            [sortOrder]="sortOrder()!"
            (toggleSort)="handleToggleSort('NF3')"
          />
        </th>
        <th class="cursor-pointer w-[10rem]">
          <app-sort-header
            columnName="CO2e"
            columnKey="Gases"
            [sortBy]="sortBy()!"
            [sortOrder]="sortOrder()!"
            (toggleSort)="handleToggleSort('CO2e')"
          />
        </th>
        <th class="cursor-pointer w-[10rem]">
          <app-sort-header
            columnName="Biomasa"
            columnKey="IsBiomass"
            [sortBy]="sortBy()!"
            [sortOrder]="sortOrder()!"
            (toggleSort)="handleToggleSort('IsBiomass')"
          />
        </th>
        <th class="cursor-pointer w-[12rem]">
          <app-sort-header
            columnName="Incertidumbre"
            columnKey="Uncertainty"
            [sortBy]="sortBy()!"
            [sortOrder]="sortOrder()!"
            (toggleSort)="handleToggleSort('Uncertainty')"
          />
        </th>
        <th class="cursor-pointer w-[12rem]">
          <app-sort-header
            columnName="Referencia"
            columnKey="Reference"
            [sortBy]="sortBy()!"
            [sortOrder]="sortOrder()!"
            (toggleSort)="handleToggleSort('Reference.Name')"
          />
        </th>
      </tr>
    </ng-template>
    <ng-template #body let-factor>
      <tr>
        <td pFrozenColumn alignFrozen="left">{{ getFactorName(factor.Code) }}</td>
        <td>
          @if (isWorldLocation(factor.Location.Country)) {
            <div class="flex items-center gap-2">
              <span class="material-symbols-outlined text-primary-500">public</span>
              <div class="flex flex-col">
                <span class="font-medium">Mundo</span>
              </div>
            </div>
          } @else if (factor.Location.Country) {
            <app-flag-image
              [countryIso2]="factor.Location.Country"
              [stateName]="factor.Location.City || ''"
            />
          } @else {
            <div class="flex flex-col">
              <span class="font-medium">{{ factor.Location.Country }}</span>
              @if (factor.Location.City) {
                <span class="text-gray-500 text-xs">{{ factor.Location.City }}</span>
              }
            </div>
          }
        </td>
        <td>{{ factor.Date?.Year }}</td>
        <td>{{ getVariationName(factor.Variation) }}</td>
        <td>{{ factor.Unit }}</td>
        <td>{{ getGasValue(factor.Gases, 'CO2') }}</td>
        <td>{{ getGasValue(factor.Gases, 'CH4') }}</td>
        <td>{{ getGasValue(factor.Gases, 'N2O') }}</td>
        <td>{{ getGasValue(factor.Gases, 'SF6') }}</td>
        <td>{{ getGasValue(factor.Gases, 'NF3') }}</td>
        <td>{{ getGasValue(factor.Gases, 'CO2e') }}</td>
        <td>
          @if (factor.IsBiomass) {
            <span class="material-symbols-outlined text-green-600">check_circle</span>
          } @else {
            <span class="material-symbols-outlined text-gray-400">cancel</span>
          }
        </td>
        <td>{{ (factor.Uncertainty * 100) | number: '1.2-2' }}%</td>
        <td>{{ factor.Reference.Name }}</td>
      </tr>
    </ng-template>
    <ng-template #emptymessage>
      <tr>
        <td colspan="15">No se encontraron factores de emisión</td>
      </tr>
    </ng-template>
  </p-table>

  <app-paginator
    [first]="first()"
    [rows]="rows()"
    [totalRecords]="totalRecords()"
    (pageChange)="pageChange.emit($event)"
  />

</div>
